import { useState, useEffect } from "react";
import SelectDeviceServer from "./steps/SelectDeviceServer";
import SetupInfluxDevice from "./steps/SetupInfluxDevice";
import SetupHuaweiDevice from "./steps/huawei/SetupHuaweiDevice";
import { useGetDevice } from "src/api/userInfo";
// import SetupVehicleDevice from "./steps/SetupVehicleDevice";
import { useTranslation } from 'react-i18next'

const SetupDevice = ({ device, onClose, isEditDevice, plantId, plantLocation }) => {
  const { mutateDeviceList} = useGetDevice(plantId);
  const { t } = useTranslation("settings");
  const [step, setStep] = useState(isEditDevice ? 2 : 1);
  const deviceBrand = isEditDevice
    ? device?.brand.toLowerCase().includes('huawei')
      ? 'huawei-cloud'
      : 'influxdb'
    : "";
  const [type, setType] = useState(deviceBrand);
  const [deviceDetails, setDeviceDetails] = useState({ isEditDevice: isEditDevice });

  useEffect(() => {
    // Reset step when type changes, unless it's an edit
    if (!isEditDevice) {
      setStep(1);
      setDeviceDetails({ isEditDevice: false });
    }
  }, [type, isEditDevice]);

  const handleOnClose = () => {
    mutateDeviceList();
    setDeviceDetails({});
    onClose();
  };

  const handleStepChange = (value) => {
    if (isEditDevice || value <= step) {
      setStep(value);
    }
  };

  const stepDetails = [
    // { step: 2, name: 'Info', description: 'Enter device information' },
    // { step: 3, name: 'Fields', description: 'Enter device fields' },
    // { step: 4, name: 'Location', description: 'Enter device location' },
    { step: 2, name: `${t('device_management.device_setup.info')}`, description: `${t('device_management.device_setup.description_info')}` },
    { step: 3, name: `${t('device_management.device_setup.fields')}`, description: `${t('device_management.device_setup.description_field')}` },
    { step: 4, name: `${t('device_management.device_setup.location')}`, description: `${t('device_management.device_setup.description_location')}` },
  ];

  return (
    <section className={''}>
      <div className="bg-black bg-opacity-60 fixed z-50 left-0 top-0 w-[100%] h-[100%] overflow-hidden flex items-center justify-center">
        <div className="flex flex-col w-[45rem] gap-2 px-8 pt-4 pb-6 bg-white rounded-md">
          <div className="flex flex-row items-center justify-between">
            <div className="flex flex-row w-full gap-1">
              <h2 className="font-bold w-[20%]">{t('device_management.device_setup.title')}</h2>
              <ol className="flex flex-row items-center gap-4 text-xs font-medium text-center text-gray-500 bg-white rounded-lg ">
                {stepDetails?.map(stepDetail => (
                  <li key={stepDetail.step} className={`p-1 rounded-full ${step == stepDetail.step ? 'text-white bg-vekin-green60' : ''}`}>
                    <button className={`flex items-center decoration-vekin-green60 ${isEditDevice ? "hover:underline" : ''}`} onClick={() => handleStepChange(stepDetail?.step)}>
                      <span className="flex items-center justify-center w-5 h-5 mr-2 text-xs border border-blue-600 rounded-full shrink-0 ">
                        {stepDetail?.step}
                      </span>
                      {stepDetail?.name}
                      <svg className="w-3 h-3 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 10">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m7 9 4-4-4-4" />
                      </svg>
                    </button>
                  </li>
                ))}
              </ol>
            </div>
            <button className="" type="button" onClick={() => handleOnClose()}><i className="text-xl ri-close-line"></i></button>
          </div>
          <hr />
          <div className="w-full">
            <SelectDeviceServer
              key={`select-${type}-${step}`}
              step={step}
              setType={setType}
              type={type}
              setStep={setStep}
              onClose={onClose}
              plantId={plantId}
            />
            {(type === 'huawei-cloud') && (
              <SetupHuaweiDevice
                key={`huawei-${type}-${step}`}
                step={step}
                setStep={setStep}
                type={type}
                handleOnClose={handleOnClose}
                plantId={plantId}
                plantLocation={plantLocation}
                deviceId={device?.id}
              />
            )}
            {(type === 'influxdbs' || type === 'influxdb' || type === 'vehicle') && (
              <SetupInfluxDevice
                key={`influx-${type}-${step}`}
                step={step}
                setStep={setStep}
                type={type}
                handleOnClose={handleOnClose}
                setDeviceDetails={setDeviceDetails}
                deviceDetails={deviceDetails}
                plantId={plantId}
                plantLocation={plantLocation}
                isEditDevice={isEditDevice}
                deviceId={device?.id}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SetupDevice;